import type { RouteRecordRaw } from 'vue-router';

import DefaultLayout from '@/layouts/DefaultLayout.vue';
import { BreadcrumbFactory } from '../utils/breadcrumbFactory.ts';

export const settingsRoutes: RouteRecordRaw[] = [
  {
    path: '/settings',
    name: 'settings',
    meta: {
      layout: DefaultLayout,
      breadcrumb: BreadcrumbFactory.static.settings(),
      sidebarSection: 'settings',
    },
    component: () => import('@/pages/SettingsPage/SettingsPage.vue'),

    children: [
      {
        path: '',
        name: 'settings-default',
        meta: {
          breadcrumb: BreadcrumbFactory.static.userSettings(),
        },
        component: () => import('@/pages/SettingsPage/pages/UserSettings/UserSettingsPage.vue'),
      },
      {
        path: '/settings/user-settings',
        name: 'user-settings',
        meta: {
          breadcrumb: BreadcrumbFactory.static.userSettings(),
        },
        component: () => import('@/pages/SettingsPage/pages/UserSettings/UserSettingsPage.vue'),
      },
      {
        path: '/settings/notifications',
        name: 'settings-notifications',
        meta: {
          breadcrumb: BreadcrumbFactory.static.notificationPreferences(),
        },
        component: () =>
          import('@/pages/SettingsPage/pages/NotificationPreferences/NotificationPreferencesPage.vue'),
      },
    ],
  },
];
